{
	"hero": {
		"title": "Выбери план под свой темп обучения",
		"subtitle": "AI-конспекты, карточки, тесты и репетитор — всё в одном"
	},
	"cycle": {
		"monthly": "Месяц",
		"annual": "Год",
		"save": "−{percent}%",
		"annualNote": "при оплате за год"
	},
	"currency": {
		"label": "Валюта",
		"rub": "RUB",
		"usd": "USD",
		"eur": "EUR"
	},
	"tiers": {
		"free": {
			"name": "Free",
			"tagline": "Бесплатно навсегда",
			"period": "навсегда",
			"features": [
				"5 материалов",
				"3 конспекта в день",
				"20 сообщений репетитору",
				"50 карточек / 2 теста в день",
				"60 минут записи лекций / месяц",
				"2 аудио-резюме / месяц"
			]
		},
		"plus": {
			"name": "Plus",
			"tagline": "Популярный",
			"popular": "Популярный",
			"period": "/мес",
			"features": [
				"100 материалов",
				"50 конспектов в день",
				"500 сообщений репетитору",
				"20 карточек / 20 тестов в день",
				"600 минут записи / месяц",
				"20 аудио-резюме / месяц",
				"Голосовой репетитор — 60 мин",
				"Эссе — 10 / месяц"
			]
		},
		"pro": {
			"name": "Pro",
			"tagline": "Максимум",
			"period": "/мес",
			"features": [
				"Безлимит материалов",
				"Безлимит AI-генераций",
				"Безлимит сообщений репетитору",
				"Безлимит записи лекций",
				"Безлимит аудио-резюме",
				"Голосовой репетитор — 300 мин",
				"Объяснения по фото и графикам",
				"Эссе с аннотациями в тексте",
				"Приоритетная очередь"
			]
		}
	},
	"cta": {
		"guest": "Начать бесплатно",
		"free": "Начать 14 дней Plus",
		"trial": "Пробный период активен",
		"current": "Текущий план",
		"upgrade": "Перейти на {tier}",
		"downgrade": "Понизить до {tier}",
		"restore": "Восстановить"
	},
	"comparison": {
		"title": "Сравнение возможностей",
		"feature": "Возможность",
		"rows": {
			"materials": "Материалы (всего)",
			"notesDaily": "Конспектов в день",
			"cardsDaily": "Карточек в день",
			"quizzesDaily": "Тестов в день",
			"tutorDaily": "Tutor сообщений в день",
			"recordingMinutes": "Запись лекций (мин/мес)",
			"audioRecaps": "Аудио-резюме в месяц",
			"essays": "Эссе в месяц",
			"voiceTutor": "Голосовой репетитор (мин/мес)",
			"priority": "Приоритетная очередь"
		}
	},
	"faq": {
		"title": "Часто задаваемые вопросы",
		"items": {
			"cancel": {
				"q": "Можно ли отменить в любой момент?",
				"a": "Да. Отмена доступна в любой момент в настройках профиля. Доступ к функциям Plus/Pro сохраняется до конца оплаченного периода."
			},
			"trial": {
				"q": "Что произойдёт после пробного периода?",
				"a": "После 14 дней пробного периода без активной подписки тариф вернётся на Free. Карта не списывается без явного подтверждения."
			},
			"payments": {
				"q": "Какие способы оплаты доступны?",
				"a": "Карты, популярные локальные методы оплаты и PayPal — набор доступных способов подстраивается под твой регион."
			},
			"refund": {
				"q": "Что если AI-генерация не сработала?",
				"a": "Если AI ошибся при генерации — мы возвращаем потраченную квоту. При системной ошибке — возврат денег."
			},
			"money": {
				"q": "Можно ли вернуть деньги?",
				"a": "В течение 14 дней с момента покупки — да, по запросу в поддержку."
			}
		}
	},
	"finalCta": {
		"title": "Готовы начать?",
		"button": "Начать 14 дней"
	},
	"footer": {
		"terms": "Условия",
		"privacy": "Конфиденциальность",
		"contacts": "Контакты"
	},
	"error": {
		"title": "Не удалось загрузить тарифы",
		"retry": "Попробовать снова"
	}
}
